import React, { useEffect, useState } from 'react';

import Brand from '../atoms/brand/brand';
import Linky from '../atoms/actions/linky';
import SearchBar from '../molecules/searchbar';
import IconSearch from '../atoms/icons/iconSearch';

const BrandHeader = ({className, brandLight, searchbar, mobile}) => {
    const [showSearchbar, setShowSearchBar] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    const handleClick = () => {
        (showSearchbar ? setShowSearchBar(false): setShowSearchBar(true));
    }

    useEffect(() => {

        isMobile();
        window.addEventListener('resize', () => { isMobile() });

        function isMobile(){
            if( window.innerWidth < 991){
                setIsMobile(true)
            }
            else{
                setIsMobile(false);
            }
        }
    })

    return ( 
        <div className={"brand-header" + (className ? ' '+className : '')}>
            <div className="container">
                <div className="row">
                    <div className="col-6">
                        <div className="d-flex justify-content-between">
                            <Linky url="/" className="">
                                {(mobile ? 
                                    <>
                                    {(isMobile ? 
                                        <Brand light={(mobile)}></Brand>
                                        :
                                        <Brand></Brand>
                                    )}
                                    </>
                                    :
                                    <Brand light={(brandLight ? true : false)}></Brand>
                                )}
                            </Linky>
                            {(searchbar ? 
                                <div className="d-none d-md-block mini-search">
                                    <div className="search-form-trigger" onClick={handleClick}>
                                        <p className="d-none d-lg-block search-label">Nouvelle recherche</p>
                                        <IconSearch></IconSearch>
                                    </div>
                                    <div className={"search-form" + (showSearchbar ? ' search-form-is-active':'')}>
                                        <SearchBar mini className=""></SearchBar>
                                    </div>
                                </div>
                            : 
                            '')}
                        </div>
                    </div>
                </div>
            </div>
        </div> 
    );
}
 
export default BrandHeader;

BrandHeader.defaultProps = {
    searchbar: true
}